import { render, staticRenderFns } from "./SmsOperatorTariffZones.vue?vue&type=template&id=59d54096&"
import script from "./SmsOperatorTariffZones.vue?vue&type=script&lang=ts&"
export * from "./SmsOperatorTariffZones.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports